export const basicRoutes = [
  {
    path: '/',
    redirect: '/officialWebsite',
    component: () => import('@/views/OfficialWebsite/layout/Index.vue'),
    children: [
      {
        path: 'officialWebsite',
        name: 'OfficialWebsite',
        component: () => import('@/views/OfficialWebsite/Index.vue'),
        meta: {
          title: '官网'
        }
      },
      {
        path: 'articleList',
        name: 'ArticleList',
        component: () => import('@/views/OfficialWebsite/Article/Index.vue'),
        meta: {
          title: '文章列表',
          keepAlive: true
        }
      },
      {
        path: 'articleDetail/:id-:slug',
        name: 'ArticleDetail',
        component: () => import('@/views/OfficialWebsite/Article/Detail.vue'),
        meta: {
          title: '文章详情'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Login/Register.vue'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/Login/PrivacyPolicy.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  {
    path: '/userPolicy',
    name: 'UserPolicy',
    component: () => import('@/views/Login/UserPolicy.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/noPermission',
    name: 'NoPermission',
    component: () => import('@/views/NoPermission.vue'),
    meta: {
      title: '无权限'
    }
  },
  {
    path: '/paySuccess',
    name: 'PaySuccess',
    component: () => import('@/views/Result/PaySuccess/Index.vue'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    show: false,
    component: () => import('@/views/PageNotFound.vue'),
    meta: {
      title: '未找到'
    }
  }
]
